import script from "./GradientButton.vue?vue&type=script&setup=true&lang=js"
export * from "./GradientButton.vue?vue&type=script&setup=true&lang=js"

import "./GradientButton.vue?vue&type=style&index=0&id=3c05633c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c05633c"]])

export default __exports__